import { Link } from "react-router-dom";
import { useLanguage } from "../i18n";
import "./QuickQuestions.css";

const copy = {
  en: {
    eyebrow: "BUBLYUP HELP",
    title: "A few quick answers",
    intro: "Start here for common questions.",
    back: "Contact Support",
    questions: [
      ["I cannot sign in. What should I do?", "Check that you are using the same sign-in method you used to create your account. Never share a password or one-time code. If you are still locked out, send a support request so the team can help verify your account."],
      ["How do I report abuse or an unsafe interaction?", "Send a report to our support team and describe what happened, including the profile or post involved if possible. Do not send intimate images or payment details. A person will review the report."],
      ["Can support help with a payment or account issue?", "Yes. Tell us which account or payment is affected and include a transaction date or reference if available. Never include your full card number, security code, password, or verification code."]
    ]
  },
  fr: {
    eyebrow: "AIDE BUBLYUP",
    title: "Quelques réponses rapides",
    intro: "Commencez ici pour trouver les réponses aux questions courantes.",
    back: "Contacter l’assistance",
    questions: [
      ["Je n’arrive pas à me connecter. Que faire ?", "Vérifiez que vous utilisez le même moyen de connexion que lors de la création du compte. Ne communiquez jamais votre mot de passe ni un code à usage unique. Si l’accès reste impossible, envoyez une demande afin que l’équipe vous aide à vérifier votre compte."],
      ["Comment signaler un abus ou une interaction dangereuse ?", "Envoyez un signalement à notre équipe en décrivant la situation et, si possible, le profil ou la publication concernés. N’envoyez pas d’image intime ni de données de paiement. Une personne examinera le signalement."],
      ["L’assistance peut-elle m’aider pour un paiement ou mon compte ?", "Oui. Précisez le compte ou le paiement concerné et, si possible, la date ou la référence de transaction. N’indiquez jamais le numéro complet de votre carte, son code de sécurité, votre mot de passe ou un code de vérification."]
    ]
  },
  es: {
    eyebrow: "AYUDA DE BUBLYUP", title: "Respuestas rápidas", intro: "Empieza aquí con las preguntas más frecuentes.", back: "Contactar con soporte",
    questions: [
      ["No puedo iniciar sesión. ¿Qué debo hacer?", "Comprueba que utilizas el mismo método de inicio de sesión que al crear tu cuenta. Nunca compartas tu contraseña ni un código de un solo uso. Si sigues sin poder acceder, envía una solicitud para que el equipo pueda ayudarte a verificar tu cuenta."],
      ["¿Cómo denuncio un abuso o una interacción peligrosa?", "Envía una denuncia al equipo de soporte y describe lo ocurrido. Si puedes, indica el perfil o la publicación. No envíes imágenes íntimas ni datos de pago. Una persona revisará la denuncia."],
      ["¿Puede ayudarme soporte con un pago o un problema de cuenta?", "Sí. Indica qué cuenta o pago está afectado e incluye la fecha o referencia de la transacción si la tienes. Nunca incluyas el número completo de tu tarjeta, el código de seguridad, tu contraseña ni un código de verificación."]
    ]
  },
  pt: {
    eyebrow: "AJUDA BUBLYUP", title: "Respostas rápidas", intro: "Comece aqui com as dúvidas mais comuns.", back: "Falar com o suporte",
    questions: [
      ["Não consigo entrar. O que devo fazer?", "Verifique se está usando o mesmo método de acesso escolhido ao criar sua conta. Nunca compartilhe sua senha nem um código de uso único. Se ainda não conseguir entrar, envie uma solicitação para que a equipe ajude a verificar sua conta."],
      ["Como denuncio abuso ou uma interação insegura?", "Envie uma denúncia ao suporte e descreva o que aconteceu. Se possível, informe o perfil ou a publicação envolvidos. Não envie imagens íntimas nem dados de pagamento. Uma pessoa analisará a denúncia."],
      ["O suporte pode ajudar com um pagamento ou problema na conta?", "Sim. Informe qual conta ou pagamento foi afetado e inclua a data ou referência da transação, se disponível. Nunca envie o número completo do cartão, o código de segurança, sua senha ou um código de verificação."]
    ]
  },
  et: {
    eyebrow: "BUBLYUPI ABI", title: "Kiired vastused", intro: "Alusta siit levinud küsimustega.", back: "Võta ühendust klienditoega",
    questions: [
      ["Ma ei saa sisse logida. Mida teha?", "Kontrolli, kas kasutad sama sisselogimisviisi, mille valisid konto loomisel. Ära jaga kunagi oma parooli ega ühekordset koodi. Kui sa ei pääse endiselt sisse, saada tugipäring, et meeskond saaks aidata sinu kontot kontrollida."],
      ["Kuidas teatada väärkasutusest või ohtlikust suhtlusest?", "Saada tugimeeskonnale teade ja kirjelda juhtunut. Võimalusel lisa asjaomane profiil või postitus. Ära saada intiimseid pilte ega makseandmeid. Teate vaatab läbi inimene."],
      ["Kas tugi saab aidata makse- või kontoprobleemiga?", "Jah. Kirjelda, millist kontot või makset probleem puudutab, ning lisa võimalusel tehingu kuupäev või viide. Ära kunagi lisa kaardi täisnumbrit, turvakoodi, parooli ega kinnituskoodi."]
    ]
  },
  no: {
    eyebrow: "BUBLYUP HJELP", title: "Noen raske svar", intro: "Start her med vanlige spørsmål.", back: "Kontakt brukerstøtte",
    questions: [
      ["Jeg får ikke logget inn. Hva bør jeg gjøre?", "Kontroller at du bruker samme innloggingsmetode som da du opprettet kontoen. Del aldri passordet eller en engangskode. Hvis du fortsatt ikke kommer inn, kan du sende en henvendelse slik at teamet kan hjelpe med å bekrefte kontoen."],
      ["Hvordan rapporterer jeg misbruk eller en utrygg interaksjon?", "Send en rapport til brukerstøtten og beskriv hva som skjedde. Ta med profilen eller innlegget hvis mulig. Ikke send intime bilder eller betalingsopplysninger. En person vil gå gjennom rapporten."],
      ["Kan brukerstøtten hjelpe med betaling eller konto?", "Ja. Fortell hvilken konto eller betaling det gjelder, og ta med dato eller referanse for transaksjonen hvis du har den. Oppgi aldri hele kortnummeret, sikkerhetskoden, passordet eller en bekreftelseskode."]
    ]
  },
  de: {
    eyebrow: "BUBLYUP HILFE", title: "Kurze Antworten", intro: "Hier findest du Antworten auf häufige Fragen.", back: "Support kontaktieren",
    questions: [
      ["Ich kann mich nicht anmelden. Was soll ich tun?", "Prüfe, ob du dieselbe Anmeldemethode verwendest wie bei der Kontoerstellung. Teile niemals dein Passwort oder einen Einmalcode. Wenn du weiterhin ausgesperrt bist, sende eine Supportanfrage, damit das Team dein Konto überprüfen kann."],
      ["Wie melde ich Missbrauch oder eine unsichere Interaktion?", "Melde dich beim Support und beschreibe, was passiert ist. Wenn möglich, nenne das betreffende Profil oder den Beitrag. Sende keine intimen Bilder oder Zahlungsdaten. Eine Person prüft die Meldung."],
      ["Kann der Support bei Zahlungs- oder Kontoproblemen helfen?", "Ja. Nenne das betroffene Konto oder die Zahlung und, falls vorhanden, Datum oder Referenz der Transaktion. Gib niemals deine vollständige Kartennummer, Sicherheitsnummer, dein Passwort oder einen Bestätigungscode an."]
    ]
  },
  ja: {
    eyebrow: "BUBLYUP ヘルプ", title: "よくある質問", intro: "よくある質問への回答はこちらから。", back: "サポートに問い合わせる",
    questions: [
      ["ログインできません。どうすればよいですか？", "アカウント作成時と同じログイン方法を使用しているか確認してください。パスワードやワンタイムコードは決して共有しないでください。ログインできない場合は、サポートに連絡してアカウント確認を依頼してください。"],
      ["不正行為や危険なやり取りを報告するには？", "サポートに状況を説明して報告してください。可能であれば、対象のプロフィールや投稿もお知らせください。親密な画像や支払い情報は送らないでください。担当者が報告を確認します。"],
      ["支払いやアカウントの問題をサポートに相談できますか？", "はい。該当するアカウントまたは支払いについて、可能であれば取引日や参照番号を添えてお知らせください。カード番号全桁、セキュリティコード、パスワード、認証コードは絶対に記載しないでください。"]
    ]
  },
  zh: {
    eyebrow: "BUBLYUP 帮助", title: "常见问题解答", intro: "从这里查找常见问题的答案。", back: "联系支持团队",
    questions: [
      ["我无法登录，该怎么办？", "请确认你使用的是创建账户时选择的同一种登录方式。切勿分享密码或一次性验证码。如果仍无法登录，请提交支持请求，让团队协助核实账户。"],
      ["如何举报滥用行为或不安全的互动？", "请向支持团队举报并描述发生的情况；如有可能，请提供相关个人资料或帖子。请勿发送私密图片或付款信息。工作人员会审核举报。"],
      ["支持团队能帮助处理付款或账户问题吗？", "可以。请说明涉及的账户或付款；如有交易日期或参考编号，也请一并提供。切勿提供完整银行卡号、安全码、密码或验证码。"]
    ]
  }
};

export default function QuickQuestions() {
  const { language } = useLanguage();
  const page = copy[language] || copy.en;

  return (
    <main className="quick-questions-page">
      <header className="quick-questions-hero">
        <span className="quick-questions-eyebrow">{page.eyebrow}</span>
        <h1>{page.title}</h1>
        <p>{page.intro}</p>
      </header>

      <section className="quick-questions-list" aria-label={page.title}>
        {page.questions.map(([question, answer], index) => (
          <details className="quick-questions-item" key={question} open={index === 0}>
            <summary>{question}<span aria-hidden="true">＋</span></summary>
            <p>{answer}</p>
          </details>
        ))}
      </section>

      <footer className="quick-questions-footer">
        <Link to="/support#contact">{page.back}<span aria-hidden="true">↗</span></Link>
      </footer>
    </main>
  );
}
